import { getTimelineList } from '@src/public/services';
import { enrichNodesWithCounts, getCommentCountByDocId } from '@src/public/services/interactionCounts';
import { getQuery } from '@src/public/utils/url';

export const changeEventListType = {
    init: 'INIT',
    refresh: 'REFRESH',
    more: 'MORE',
    filter: 'FILTER',
};

export const changeEventList = async ({ query, type, changeData, prevNodes = [] }) => {
    // initSize 是用于初次请求接口加载多页数据时使用的，必须是size的倍数
    const { id, page, size, party, highlights, order, initSize } = query;

    // 获取列表数据前
    if (type === changeEventListType.refresh) {
        changeData({ nodes: [], listLoading: true });
    }

    // 获取列表数据
    const res = await getTimelineList({ id, page, size: initSize || size, party, highlights, order });
    const { nodes: rawNodes = [], pagination, parties, timeline } = res;
    const { total } = pagination;
    const nodes = await enrichNodesWithCounts(rawNodes);

    if (type === changeEventListType.init) {
        const {
            id: timelineId,
            allowComment,
            finish,
            follow,
            displayTitle: title,
            summary = '',
            shareImgUrl = '',
            interactionRsp,
            showDanmu,
            cutOff,
            liveInfo,
        } = timeline;
        const party = Number(getQuery(location.href, 'tabId')) || parties[0].id;

        const addPageNum = initSize ? initSize / size : 1;

        changeData({
            id: timelineId,
            order: finish === 1 ? 'asc' : 'desc',
            page: page + addPageNum,
            parties,
            total,
            nodes,
            allowComment: allowComment === 1,
            title,
            summary,
            shareImgUrl,
            finish,
            follow: follow === 1,
            party,
            interactionRsp,
            showDanmu: showDanmu === 1,
            cutOff: cutOff === 1,
            liveInfo,
        });

        // 页面评论数拉取完成后更新到底部评论入口
        getCommentCountByDocId(timelineId).then(count => {
            changeData({
                interactionRsp: {
                    ...(interactionRsp || {}),
                    comment: count,
                },
            });
        });

        return { title };
    } else if (type === changeEventListType.refresh) {
        changeData({ nodes, page: page + 1, total, listLoading: false });
    } else if (type === changeEventListType.more) {
        changeData({
            nodes: [...prevNodes, ...nodes],
            page: page + 1,
            total,
        });
    }
};
